import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { Dialog } from "@mui/material";
import icon from "../../assets/images/linkIcon.svg";
import { pushAlert } from "../../utils/alertSlice";

const RequestAccessDialog = ({ open, onClose2, close, handleSubmitData, onClose }) => {
  const [url, Seturl] = useState("https://WWW.1d.com/en100/en100/en100/en100/en100//");

  const dispatch = useDispatch();

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        dispatch(pushAlert({ message: "Copied", type: "success", visible: true }));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <Dialog open={open} fullWidth onClose={onClose}>
      <div className="p-4 w-full h-full">
        <div className="flex justify-between items-center">
          <span className="text-2C495D font-semibold text-xl">Request Access</span>
          <button
            onClick={onClose}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto end-0 items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only flex float-end">Close modal</span>
          </button>
        </div>

        <div className="border b"></div>

        {/* Email part */}

        <div className="pt-4">
          <h3 className="text-[#2C495D] text-xl">Email</h3>
          <div className="flex items-center rounded-md w-full border">
            <input
              className="flex-1 bg-transparent py-4 px-3 "
              type="text"
              name="email"
              placeholder="Add name, group, or email"
              style={{
                border: "none",
                outline: "none",
                boxShadow: "none",
              }}
            />

            <select className="border-l border-gray-300 rounded-md outline-none px-4 py-1 bg-[#F3F5F7] text-left  cursor-pointer">
              <option value="edit" className="cursor-pointer">
                Can Edit
              </option>
              <option value="view" className="cursor-pointer">
                Can View
              </option>
            </select>
          </div>
        </div>

        {/*Message field  */}

        <div>
          <h3 className="text-[#2C495D] text-xl mt-2">Add a Message</h3>
          <textarea
            className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B text-12 active:border active:border-DFE2E5 text-gray-900 text-xs block w-full p-2.5 h-20"
            type="message"
            name="description"
            placeholder="Enter Message"
          />
        </div>

        {/* Link section */}
        <div className="">
          <h3 className="text-[#434852] text-14px text-xl mt-2"> Link</h3>
          <div className="border bg-white w-full h-full py-5 px-6 rounded-md mt-2 flex justify-between items-center">
            <div>
              <p className="text-gray-600 pl-3">{url}</p>
            </div>
            <button className="border bg-[#F3F5F7] p-2 flex gap-1 rounded-md items-center">
              <span className="whitespace-nowrap" onClick={() => handleCopy(url)}>
                Copy Link
              </span>
              <img src={icon} alt="Link Icon" className="text-gray-500 cursor-pointer" />
            </button>
          </div>
        </div>

        <div className="flex justify-end py-4  text-md w-full">
          <div className="px-6">
            <button
              onClick={onClose && onClose2}
              type="button"
              className="w-28 text-[#FFFFFF] bg-[#1D4469]  rounded-md py-3 px-3"
            >
              send
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default RequestAccessDialog;
